import React from 'react';

export default class CordellConnectPackageZones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      geography: []
    };
  }


  setZones(geography, selectedGeography) {
    if (this.props.packageKey === 'trial') {
      this.setState({
        geography: geography
      });
    } else {
      for (let state in geography.metro) {
        geography.metro[state].selected = false;
      }

      if (selectedGeography.state_type === 'metro') {
        for (let state of selectedGeography.states) {
          for (let geoState in geography.metro) {
            if (geoState === state) {
              geography.metro[geoState].selected = true;
            }
          }
        }
      }
      this.setState({
        geography: geography
      });
    }
  }

  componentDidMount() {
    this.setZones(this.props.geography, this.props.selectedGeography);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.geography !== this.props.geography ||
      prevProps.selectedGeography !== this.props.selectedGeography ||
      prevProps.packageKey !== this.props.packageKey
    ) {
      this.setZones(this.props.geography, this.props.selectedGeography);
    }
  }

  render(props) {
    return (
      <div className='panel-body-spacing'>
        {Object.keys(this.state.geography).map(function (key, index) {
          let item = this.state.geography[key];
          let classNames = require('classnames');
          let stateTypeClass = classNames({
            'alert': key !== 'limited',
            'alert alert-success': key === 'limited'
          });
          let tileClass = classNames({
            'col-sm-10': key !== 'limited',
            'col-sm-12': key === 'limited'
          });
          return (
            <div className={stateTypeClass} key={index}>
              <div className='row body'>
                <div className={tileClass}>
                  {key === 'metro' && <span>Metro</span>}
                  {key === 'full_state' && <span>Full State</span>}
                  {key === 'national' && <span>National</span>}
                  {key === 'limited' && (
                    <span>
                      <span>Limited</span>
                      <span className='float-right'>$0</span>
                    </span>
                  )}
                  {key === 'metro' && (
                    <div className='row margin-10'>
                      {Object.keys(item)
                        .slice(0, 5)
                        .map(function (state, subIndex) {
                          let stateClass = classNames({
                            'alert col-sm-5 margin-right-20': !item[state].selected,
                            'alert alert-success col-sm-5 margin-right-20': item[state].selected
                          });
                          return (
                            <div
                              className={stateClass}
                              key={subIndex}
                              onClick={() => {
                                this.props.onZonesSelect(item[state].key, key);
                              }}
                            >
                              <span>{item[state].name}</span>
                              <span className='float-right'>${item[state].price}</span>
                            </div>
                          );
                        }, this)}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        }, this)}
        <button
          type='submit'
          className='btn btn-primary float-right btn-continue margin-bottom-10'
          onClick={() => {
            this.props.onGeographyClickAction();
          }}
        >
          Continue
        </button>
      </div>
    );
  }
}
